export default __webpack_public_path__ + "assets/icons/signed.0e3aecd8.svg";